export const enum GAMES_KEYS {
  WinterSports = 'winter-sports',
  SummerSports = 'summer-sports',
}
